export default "/fonts/vendor/remixicon/remixicon.eot?5cb99e6cba5a4619063f73d47b775f6f";